import { Injectable } from '@angular/core';
import { BaseApiPickerImpl } from '../base.api-picker';
import { OperationalDataApi } from './operational-data.api';
import { OperationalDataMockApi } from './operational-data.mock.api';
import { AuthStore } from '@store';

@Injectable({ providedIn: 'root' })
export class OperationalDataApiPicker extends BaseApiPickerImpl<
  OperationalDataApi | OperationalDataMockApi
> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: OperationalDataApi,
    protected mockApi: OperationalDataMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
